export default __webpack_public_path__ + "static/media/sad-darsad.042d7d53.svg";